import {ActivatedRoute} from "@angular/router";
import {ServeurResultatsResultatsComponent} from "./resultats/serveur-resultats-resultats.component";
import {RechercheDossierDto} from "@resources/resources";
import {ArianeElement, ArianeStore} from "@digicerba/common";
import {Component, ViewChild} from "@angular/core";

@Component({
  selector: 'serveur-resultats',
  templateUrl: './serveur-resultats.component.html',
  host: { 'class': 'page' }
})
export class ServeurResultatsComponent {

  @ViewChild(ServeurResultatsResultatsComponent) resultats: ServeurResultatsResultatsComponent;

  rechercheDossierDto: RechercheDossierDto = null;
  hprimEnabled: Boolean = true;
  reemissionEnabled: Boolean = true;

  constructor(arianeStore: ArianeStore, private activateRoute: ActivatedRoute) {
    let arianeElements: Array<ArianeElement>;
    arianeElements = [
      {
        libelle: "ARIANE.SERVEUR-RESULTATS",
        route: "/"
      }
    ]
    arianeStore.updateElements(arianeElements);
  }

  ngOnInit() {
    this.activateRoute.data.subscribe((data) => {
      const emissionHprimDebounce = data['emissionHprimDebounceExamen'];
      this.hprimEnabled = emissionHprimDebounce.hprimEnabled;
      this.reemissionEnabled = emissionHprimDebounce.reemissionEnabled;
    });
  }

  filtreData(rechercheDto: RechercheDossierDto) {
    this.rechercheDossierDto = rechercheDto;
  }

  exportCsv() {
    this.resultats.exportCsv();
  }

  exportFacturation() {
    this.resultats.exportFacturation();
  }

  isHPrimEnabled() {
    return this.hprimEnabled;
  }

  isReemissionEnabled() {
    return this.reemissionEnabled;
  }

}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-serveur-resultats/digicerba-serveur-resultats-web/src/angular/cerba/src/app/pages/cerba/pages/serveur-resultats/serveur-resultats.component.ts